import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { UpperCasePipe } from '@angular/common';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { NgSelectComponent } from '@ng-select/ng-select';
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { StorageService } from "app/services/storage.service";
import { Storage } from 'app/models/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Tag } from 'app/models/tag';
import { TagService } from 'app/services/tag.service';
import * as _ from "lodash";
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { StorageChooserComponent } from './storage-chooser/storage-chooser.component';
import { UserService } from 'app/services/user.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-storage',
  templateUrl: './storage.component.html',
  styleUrls: ['./storage.component.scss']
})
export class StorageComponent implements OnInit, AfterViewInit {

  tags: Tag[];
  filterTags: Tag[] = [];

  constructor(private storageService: StorageService, private _route: Router,
    public tagService: TagService, private ecoDocsTitleService: EcoDocsTitleService,
    private activatedRoute: ActivatedRoute, public userService: UserService) {

    this.tagService.currentTagsSubject.subscribe(t => this.tags = t);

    this.storageService.getAll('custom_only_include_deleted').subscribe(storages => {
      this.storages = storages;
      this.unfilteredStorages = storages;
      setTimeout(() => { this.tableLoadingIndicator = false; }, 100);
    });

  }
  
  ngOnInit() {
    this.ecoDocsTitleService.setTitle( 'Manage Storage', false );

    this.loadingStorageIds = [];
  }

  ngAfterViewInit(): void {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      const action = queryParams['action']? queryParams['action']: '';
  
      if (action == 'createNewStorage') {
        this.storageChooser.show();
      }
    });    
  }
  
  @ViewChild(DatatableComponent, { static: true }) table: DatatableComponent;
  @ViewChild('addModal', { static: true }) addModal: ModalDirective;
  @ViewChild('storageChooser', { static: false }) storageChooser: StorageChooserComponent;

  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedTableLimit = 5;
  tableLoadingIndicator: boolean = true;

  storages: Storage[];
  unfilteredStorages: Storage[] = [];
  storagesFilter: string = null;
  filterActive: number = 0;
  filterType: string[] = [];
  filterScope: number = 0;

  loadingStorageIds: number[] = [];


  filterActiveOptions = [
    { value: 0, label: 'Any', selected: true },
    { value: 1, label: 'Active Only' },
    { value: 2, label: 'Inactive Only' }
  ];


  storageTypes = [
    { value: 's3', label: 'Amazon S3' },
    { value: 'dropbox', label: 'Dropbox' },
    { value: 'google', label: ' Google Drive' },
    { value: 'one', label: ' One Drive' },
    { value: 'box', label: 'Box' },
    { value: 'webdav', label: 'WebDav' },
    { value: 'sftp', label: 'SFTP' },
    { value: 'ftp', label: 'FTP' }

  ];

  innerWidth() {
    return window.innerWidth;
  }

  getFormattedNameFromDriver(driver: string) {
    let result: string = driver;

    const storageIndex: number = this.storageTypes.findIndex((storageType) => {return storageType.value == driver;});
    if (storageIndex != -1)
      result = this.storageTypes[storageIndex].label;

    return result;
  }
  UpdateStorage(id: number, driver: string) {
    switch (driver) {
      case 's3':
        this._route.navigate([`/manage/storage/add-amazon/${id}`]);
        break;
      case 'dropbox':
        this._route.navigate([`/manage/storage/add-cloud/dropbox/${id}`]);
        break;
      case 'google':
        this._route.navigate([`/manage/storage/add-cloud/google/${id}`]);
        break;
      case 'webdav':
        this._route.navigate([`/manage/storage/add-webdav/${id}`]);
        break;
      case 'sftp':
        this._route.navigate([`/manage/storage/add-sftp/${id}`]);
        break;
      case 'ftp':
        this._route.navigate([`/manage/storage/add-ftp/${id}`]);
        break;
      case 'onedrive':
        this._route.navigate([`/manage/storage/add-cloud/onedrive/${id}`]);
        break;
      case 'box':
        this._route.navigate([`/manage/storage/add-cloud/box/${id}`]);
        break;

    }
  }

  updateFilter() {


    const val = (this.storagesFilter) ? this.storagesFilter.toLowerCase() : null;

    // filter our data
    const temp = this.unfilteredStorages.filter((storage: Storage) => {

      return (
        //text filter
        storage.display_name.toLowerCase().indexOf(val) !== -1 || !val)
        &&
        // Tags filter
        (this.filterTags.length == 0 || _.intersectionWith(this.filterTags, storage.tags, (a, b)=>{return a.name == b.name}).length > 0)

        &&
        //Type Filter
        (this.filterType.length == 0 || this.filterType.indexOf(storage.driver)!==-1);
    });

    // update the rows
    this.storages = temp;

    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  onActivateChanged(event, storage: Storage) {
    if (event.target.checked) {
      if (!this.loadingStorageIds.includes(storage.id)) {
        this.storageService.restore(storage.id).pipe(map(x => {
          /** @todo handle error */
          storage.deleted_at = null;
          this.loadingStorageIds = this.loadingStorageIds.filter(id => id != storage.id);
          this.storages = [...this.storages];
        })).subscribe();
        this.loadingStorageIds.push(storage.id);
      }
    } else {
      if (!this.loadingStorageIds.includes(storage.id)) {
        this.storageService.deactivate(storage.id).subscribe(x => {
          /** @todo handle error */
          storage.deleted_at = new Date();
          this.loadingStorageIds = this.loadingStorageIds.filter(id => id != storage.id);
          this.storages = [...this.storages];
        });
        this.loadingStorageIds.push(storage.id);
      }
    }
  }
}
